import React from 'react';
import { motion } from 'framer-motion';

interface RefreshButtonProps {
    onClick: () => void;
    isRefreshing: boolean;
    lastUpdate: string | null;
}

export const RefreshButton: React.FC<RefreshButtonProps> = ({
    onClick,
    isRefreshing,
    lastUpdate,
}) => {
    return (
        <motion.button
            onClick={onClick}
            disabled={isRefreshing}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-[var(--bg-elevated)] border border-[var(--border)] text-[var(--text-secondary)] text-[12px] hover:border-[var(--border-strong)] hover:text-[var(--text)] transition-all disabled:opacity-50"
        >
            <motion.svg
                width="14"
                height="14"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
                animate={isRefreshing ? { rotate: 360 } : { rotate: 0 }}
                transition={isRefreshing ? { duration: 1, repeat: Infinity, ease: "linear" } : {}}
            >
                <polyline points="23 4 23 10 17 10" />
                <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
            </motion.svg>
            <span className="hidden sm:inline">
                {isRefreshing ? 'Обновление...' : lastUpdate ? `Обновлено ${lastUpdate}` : 'Обновить'}
            </span>
        </motion.button>
    );
};